import React from "react";
import classNames from "classnames";

import Overlay from "../overlay/OverlayController.jsx";
import Button from "../button/ButtonController.jsx";

export default function Confirm(props) {
  const {
    className,
    confirmButtonText = "Ok",
    abortButtonText = "Abort",
    text,
    active,
    children,
    onConfirmClick,
    onAbortClick,
    ...rest
  } = props;

  return (
    <Overlay className={classNames("confirm", className)} active={active}>
      <div className="confirm__text">{text || children}</div>
      {confirmButtonText && (
        <Button className="confirm__confirm-button" onClick={onConfirmClick}>
          {confirmButtonText}
        </Button>
      )}
      {abortButtonText && (
        <Button className="confirm__abort-button" onClick={onAbortClick}>
          {abortButtonText}
        </Button>
      )}
    </Overlay>
  );
}
